import React from 'react';
import { useWidgetBuilder } from '../context/WidgetBuilderContext';
import { WIDGET_TYPES } from '../lib/WidgetConstants';
import { useDraggable } from '@dnd-kit/core';
import { Layers, CheckCircle2, GripVertical } from 'lucide-react';
import api from '../lib/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export default function WidgetManagerDrawer() {
  const { isEditing, toggleEditing, saveLayout } = useWidgetBuilder();
  const queryClient = useQueryClient();

  if (!isEditing) return null;

  return (
    <>
      
      
      {/* Drawer */}
      <div className="fixed top-0 left-0 bottom-0 w-80 bg-[#0d111a] border-r border-white/10 z-50 flex flex-col shadow-2xl animate-in slide-in-from-left">
        <div className="p-4 border-b border-white/10 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Layers className="w-5 h-5 text-[var(--tf-primary)]" />
            <h2 className="font-bold text-white text-lg">Block Manager</h2>
          </div>
          <button onClick={toggleEditing} className="text-zinc-500 hover:text-white transition-colors">
            <i className="fa-solid fa-times"></i>
          </button>
        </div>

        <div className="p-4 bg-white/5 border-b border-white/10 text-xs text-zinc-400 leading-relaxed">
          Drag available blocks from this list into the block areas to add them to your community.
          <br /><br />
          Users will only see blocks they have permission to view.
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-3 scrollbar-hide">
          <h3 className="text-xs font-bold text-white uppercase tracking-wider mb-2">Available Blocks</h3>
          
          {WIDGET_TYPES.map((wt) => (
            <DraggableWidgetType key={wt.value} type={wt} />
          ))}
        </div>

        <div className="p-4 border-t border-white/10 bg-black/20">
          <button 
            onClick={toggleEditing}
            className="w-full bg-[var(--tf-primary)] hover:bg-[var(--tf-primary-hover)] text-white font-bold py-3 rounded-lg flex items-center justify-center gap-2 transition-colors"
          >
            <CheckCircle2 className="w-5 h-5" />
            Finish Editing
          </button>
        </div>
      </div>
    </>
  );
}

function DraggableWidgetType({ type }) {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `new_${type.value}`,
    data: {
      isNew: true,
      type: type.value,
      label: type.label
    }
  });

  const style = transform ? {
    transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
    zIndex: isDragging ? 999 : undefined,
    opacity: isDragging ? 0.8 : 1,
  } : undefined;

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className={`bg-black/40 border border-white/10 p-3 rounded flex flex-col gap-1 cursor-grab active:cursor-grabbing hover:border-white/20 transition-colors ${isDragging ? 'ring-2 ring-[var(--tf-primary)]' : ''}`}
    >
      <div className="flex items-center justify-between">
        <span className="font-bold text-sm text-white">{type.label}</span>
        <GripVertical className="w-4 h-4 text-zinc-500" />
      </div>
      <span className="text-[10px] text-zinc-500">Drag to a highlighted area</span>
    </div>
  );
}
